<app-loading *ngIf="contentReady"></app-loading>

<div class="container mt-3 full-product" style="margin-bottom: 80px;" *ngIf="product">



  <!-- Bundle Name -->
  <h5 class="mt-2 text-center">
    {{ isAr ? product.name_ar : product.name_en }}
  </h5>

  <!-- Bundle Image -->
  <div class="product-img">

    <!-- Discount -->
    <div *ngIf="calcDis(product.pricea,product.price) != 0" class="discountbadge">
      {{calcDis(product.pricea,product.price)}}%
      {{ "discount" | transloco }}
    </div>
    <div class="swiper bundle-swiper" #bundleSwiper *ngIf="bundleSlides.length">

      <div class="swiper-wrapper">

        <div class="swiper-slide" *ngFor="let img of bundleSlides">

          <img class="product-img" [lazyLoad]="img" [defaultImage]="'/assets/imageloading.gif'"
            [errorImage]="'/assets/noproduct.png'" alt="bundle" />
        </div>

      </div>

      <!-- Pagination + Arrows -->
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>

    </div>


  </div>

  <!-- Price -->
  <div class="d-flex align-items-center justify-content-between mt-3">

    <div>
      <span class="new-price">
        {{product.pricea}} {{ "egpe" | transloco }}
      </span>

      <span class="old-price" *ngIf="calcDis(product.pricea,product.price) != 0">
        {{product.price}} {{ "egpe" | transloco }}
      </span>
    </div>
  </div>

  <!-- التابات -->
  <div class="tabs mt-4">
    <button class="active"> {{ "Show Description" | transloco }}</button>
  </div>

  <p class="mt-2 product-info">
    <ng-container [ngSwitch]="product?.items[0].pet">
      <span *ngSwitchCase="'0'">
        <img src="/assets/e-commerce/icons/8.webp">
        {{ "cats" | transloco }}
      </span>
      <span *ngSwitchCase="'1'">
        <img src="/assets/e-commerce/icons/11.webp">
        {{ "dogs" | transloco }}
      </span>
      <span *ngSwitchCase="'2'">
        <img src="/assets/e-commerce/icons/13.webp">
        {{ "birds" | transloco }}
      </span>
      <span *ngSwitchCase="'4'">
        <img src="/assets/e-commerce/icons/10.webp">
        {{ "cats&dogs" | transloco }}
      </span>
      <span *ngSwitchCase="'3'">
        <img src="/assets/e-commerce/icons/25.png">
        {{ "other" | transloco }}
      </span>
    </ng-container>

    <br>
    @if(isAr){
    {{product.name_ar}}
    <br>
    {{product.description_ar}}
    }
    @else{
    {{product.name_en}}
    <br>
    {{product.description_en}}
    }

  </p>


  <!-- Bundle Items -->
  <div class="bundle-items-premium" *ngIf="product?.items?.length">
    <div class="tabs mt-4">
      <button class="active"> {{ "Show Bundle Items" | transloco }}</button>
    </div>

    <!-- MAIN BUNDLE SLIDER -->


    <div class="bundle-chip" *ngFor="let item of product.items">

      <div class="chip-img">
        <img [lazyLoad]="fixImage(item.stock.image)" />
      </div>

      <div class="chip-text">
        <span class="chip-qty">×{{ item.quantity }}</span>
        <span class="chip-name">
          {{ isAr ? item.stock.name_ar : item.stock.name_en }}
        </span>
      </div>




    </div>

    <div class="trust-box row">
      <h6 class="text-primary"> {{ "trustshopping" | transloco }} </h6>

      <div class="col-6 col-md-3 mb-3" style="text-align: center;">
        <img src="/assets/e-commerce/icons/40.webp">
        <br>
        {{ "cashpayment" | transloco }}
      </div>
      <div class="col-6 col-md-3 mb-3" style="text-align: center;">
        <img src="/assets/e-commerce/icons/41.webp">
        <br>
        {{ "returns" | transloco }}
      </div>
      <div class="col-6 col-md-3 mb-3" style="text-align: center;">
        <img src="/assets/e-commerce/icons/42.webp">
        <br>
        {{ "cashback" | transloco }}
      </div>
      <div class="col-6 col-md-3 mb-3" style="text-align: center;">
        <img src="/assets/e-commerce/icons/43.webp">
        <br>
        {{ "trusttrans" | transloco }}
      </div>







    </div>
    <!-- Quantity -->
    <div class="quantity-controls cartpage mt-4">
      <button (click)="min(product)" class="btn btn-outline-secondary">-</button>
      <span>{{quantity}}</span>
      <button (click)="plus(product)" class="btn btn-outline-secondary">+</button>
    </div>

    <!-- Add To Cart -->
    <button class="btn btn-add mt-3" (click)="plus(product)">
      {{ "addtocart" | transloco }}
    </button>

    <!-- SHARE BUTTON -->
    <div class="share-box ">

      <button class="btn btn-add" (click)="toggleShare()">
        {{ 'Share' | transloco }}
      </button>

      <div class="share-sheet mt-3" *ngIf="showShare">

        <div class="share-item" (click)="shareFacebook()">
          <img src="/assets/share/facebook.svg" />
          <span> {{ 'Facebook' | transloco }}</span>
        </div>

        <div class="share-item" (click)="shareWhatsApp()">
          <img src="/assets/share/whatsapp.svg" />
          <span>{{ 'WhatsApp' | transloco }}</span>
        </div>

        <div class="share-item" (click)="shareTelegram()">
          <img src="/assets/share/telegram.svg" />
          <span>{{ 'Telegram' | transloco }}</span>
        </div>

        <div class="share-item" (click)="copyShareLink()">
          <img src="/assets/share/link.svg" />
          <span>{{ 'Copy' | transloco }}</span>
        </div>

      </div>
    </div>
    <app-productrecommendation style="padding: 0!important;"></app-productrecommendation>
  </div>